<template>
  <v-menu location="right" min-width="150">
    <template #activator="{ props }">
      <app-button type="icon" v-bind="props">
        <app-material-icon name="more_horiz"/>
      </app-button>
    </template>
    <v-list class="py-0">
      <v-list-item
        v-for="item in itemMenu"
        :key="item.action"
        @click="handleMenuAction(item.action)"
      >
        <template v-if="item.icon || item.img" #prepend>
          <div :class="item.class" class="mr-2">
            <img v-if="item.img"
                 :src="item.img"
                 :alt="item.text"
                 class="menu-item-img"
            />
            <app-material-icon v-else :name="item.icon"/>
          </div>
        </template>
        <v-list-item-title :class="item.class">{{ item.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import { mapMutations } from 'vuex'
  
  import moveIcon from '@/assets/img/icons/move_icon.svg'
  import { FOLDER_MAX_DEPTH } from '@/common/constants'
  import {
    SET_ROOM_TO_MOVE,
    SET_MOVE_ROOM_DIALOG_IS_OPEN,
  } from '@/store/modules/projects-folders/mutation_types'
  import {
    SET_PROJECTS_FOLDER_DELETE_DIALOG_IS_OPEN,
    SET_PROJECTS_FOLDER_TO_DELETE,
  } from '@/store/modules/projects-folders-delete/mutation_types'
  import {
    SET_PROJECTS_FOLDER_MOVE_DIALOG_IS_OPEN,
    SET_PROJECTS_FOLDER_TO_MOVE,
  } from '@/store/modules/projects-folders-move/mutation_types'
  import {
    SET_PROJECTS_FOLDER_RENAME_DIALOG_IS_OPEN,
    SET_PROJECTS_FOLDER_TO_RENAME,
  } from '@/store/modules/projects-folders-rename/mutation_types'

  export default {
    name: 'ProjectsFoldersGridMenu',
    props: {
      // Room or Folder
      item: {
        type: Object,
        required: true,
      },
      isRoom: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      itemMenu () {
        const menu = []
        if (this.isRoom) {
            menu.push({
              img: moveIcon,
              text: this.$t('common.move'),
              action: 'move',
            })
        } else {
          menu.push({
            icon: 'edit',
            text: this.$t('common.rename'),
            action: 'edit',
          })
          if (this.item.maxDepth < FOLDER_MAX_DEPTH || this.item.depth === FOLDER_MAX_DEPTH) {
            menu.push({
              img: moveIcon,
              text: this.$t('common.move'),
              action: 'move',
            })
          }
          menu.push({
            icon: 'delete',
            text: this.$t('common.delete'),
            action: 'delete',
            class: 'text-error',
          })
        }
        return menu
      },
    },
    methods: {
      ...mapMutations('projectsFolders', [
        SET_ROOM_TO_MOVE,
        SET_MOVE_ROOM_DIALOG_IS_OPEN,
      ]),
      ...mapMutations('projectsFoldersRename', [
        SET_PROJECTS_FOLDER_RENAME_DIALOG_IS_OPEN,
        SET_PROJECTS_FOLDER_TO_RENAME,
      ]),
      ...mapMutations('projectsFoldersMove', [
        SET_PROJECTS_FOLDER_MOVE_DIALOG_IS_OPEN,
        SET_PROJECTS_FOLDER_TO_MOVE,
      ]),
      ...mapMutations('projectsFoldersDelete', [
        SET_PROJECTS_FOLDER_DELETE_DIALOG_IS_OPEN,
        SET_PROJECTS_FOLDER_TO_DELETE,
      ]),
      handleMenuAction (action) {
        switch (action) {
          case 'edit':
            if (!this.isRoom) { // Rename folder
              this.SET_PROJECTS_FOLDER_TO_RENAME(this.item)
              this.SET_PROJECTS_FOLDER_RENAME_DIALOG_IS_OPEN(true)
            }
            break
          case 'move':
            if (this.isRoom) {
              this.SET_ROOM_TO_MOVE(this.item)
              this.SET_MOVE_ROOM_DIALOG_IS_OPEN(true)
            } else {
              this.SET_PROJECTS_FOLDER_TO_MOVE(this.item)
              this.SET_PROJECTS_FOLDER_MOVE_DIALOG_IS_OPEN(true)
            }
            break
          case 'delete':
            if (!this.isRoom) {
              this.SET_PROJECTS_FOLDER_TO_DELETE(this.item)
              this.SET_PROJECTS_FOLDER_DELETE_DIALOG_IS_OPEN(true)
            }
            break
        }
      },
    },
  }
</script>

<style scoped>
  .menu-item-img {
    /* To align with fa icon width */
    width: 22px;
    margin-left: 2px;
  }
</style>
